let messages = {};

import * as nl from './nl/messages.json';
import * as en from './en/messages.json';

messages = Object.assign(messages, nl.default);
messages = Object.assign(messages, en.default);

export default messages;
